import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";

import { Formik, Form, Field, Textarea, ErrorMessage } from "formik";
import * as Yup from "yup";
import { GiCrossedBones } from 'react-icons/gi';
import { LuSave } from 'react-icons/lu';
import { useGetAreaByIdQuery, useSaveAreaMutation } from "../../../../services/redux/api/components";
import { toast } from "react-toastify";

const AddAreaMaster = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const isEditMode = Boolean(id);   // Determine if in edit mode based on presence of id
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [saveArea] = useSaveAreaMutation();
  const { data: AreaData, isLoading } = useGetAreaByIdQuery(id, { skip: !isEditMode });

  console.log("AreaData:", AreaData?.data?.AreaName);
  const initialValues = {
    areaName: AreaData?.data?.AreaName || "",
    areaDescription: AreaData?.data?.AreaDescription || "",
  }

  console.log("initialValues:", initialValues);
  // Form Validation Schema just for checking 
  const validationSchema = Yup.object({
    areaName: Yup.string().required("Area Name is required"),
  });

  // Submit Whole Form
const handleSubmit = async (values, { resetForm }) => {
  const payload = {
    Mode: isEditMode ? "Update" : "Add",
    AreaID: isEditMode ? Number(id) : null,
    AreaName: values.areaName,
    AreaDescription: values.areaDescription,
  };

  // AreaID handled above based on mode

  console.log("Payload being sent:", payload);

  try {
    const response = await saveArea(payload).unwrap();
    if (response?.Status === "SUCCESS" || response?.success === true) {
      toast.success(response?.Message || "Area saved successfully");
      resetForm();
      window.history.back();
    } else {
      toast.error(response?.Message || "Failed to save Area");
    }
  } catch (error) {
    console.error("API Error:", error);
    toast.error(error?.data?.Message || "An error occurred while saving the Area");
  }
};


  return (
    <div className="formContainer  lg:p-5">
      <div className="flex flex-col lg:mx-5 p-4 border rounded bg-white" style={{ boxShadow: "0px 0px 12px #cac8c8" }}>
        <h5 className="text-brandRed font-bold border-b border-brandRed pb-2 mb-4 px-2">Area Master</h5>
        {/* Formik Form */}
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
          enableReinitialize={true}
        >

          {({ isSubmitting, setFieldValue, values }) => (
            <Form id="areaForm">
              <div className="row">
                <div className="col-md-6 w-1/2">
                  <label className="form-label">Area Name <span className="text-danger">*</span>
                  </label>
                  <Field type="text" name="areaName" className="form-control custom-shadow" />
                  <ErrorMessage name="areaName" component="div" className="text-danger" />
                </div>
                <div className="col-md-12 w-1/2 mt-3">
                  <label className="form-label">Description</label>
                  <Field as="textarea" name="areaDescription" className="form-control custom-shadow" rows="4" />
                </div>
              </div>

              <div className="d-flex justify-content-start gap-3 mt-5 justify-content-center">
                <button type="submit" className=" saveButton d-flex" disabled={isSubmitting}>
                  <span className="m-auto p-1"><LuSave /></span>{isSubmitting ? "Saving..." : "Save"}
                </button>
                <div className="flex gap-3">
                  <button type="button" className="d-flex  backButton d-flex" onClick={() => window.history.back()}> <span className="m-auto p-1"><GiCrossedBones /></span>Cancel</button>
                </div>
              </div>
              {/* Submit Button */}
              {/* <div className="mt-4 d-flex justify-content-left">
              <button type="submit" className="btn btn-warning text-white" disabled={isSubmitting}>
                Save
              </button>
            </div> */}
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default AddAreaMaster;